import React from "react";

import { Box, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { colors } from "@zapalacorp/tokens";
import { Button } from "Components/Form";

const LockIcon = require("Assets/icons/lock.svg");

// Styled Components
const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(4),
  height: "100%",
  width: "100%",
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#F5F8FA",
  borderRadius: "50%",
  marginBottom: theme.spacing(3),
}));

const StyledLockIcon = styled("img")(({ theme }) => ({
  width: "250px",
  height: "200px",
  padding: "45px 85px",
  color: theme.palette.grey[500],
}));

const Title = styled("div")(({ theme }) => ({
  color: colors.gray800,
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "28px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "36px",
  marginBottom: theme.spacing(3),
  maxWidth: "500px",
}));

const Description = styled("div")(({ theme }) => ({
  color: colors.gray600,
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  marginBottom: theme.spacing(3),
  width: "100%",
  whiteSpace: "pre-wrap",
}));

const LiveTrackingUnAvailable: React.FC = () => {
  const { t: translate } = useTranslation();

  return (
    <Wrapper>
      <IconWrapper>
        <StyledLockIcon src={LockIcon} alt={translate("realTimeTrackingUnavailable")} />
      </IconWrapper>
      <Title>
        <div>{translate("realTimeTrackingUnavailable")}</div>
      </Title>
      <Description>
        {translate(
          "liveTrackingIsUnavailableOnYourCurrentPlanUnlockThisFeatureByUpgradingYourPlanOrContactingOurSupportTeamForAssistance"
        )}
      </Description>
    </Wrapper>
  );
};

export default LiveTrackingUnAvailable;
